import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { ProxyVoteJobsTable } from '../../../../../../../../../../features/proxyvote/job/proxyvote-jobs-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorBetaNxt,
      label: 'Proxy Vote Jobs',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorBetaNxt>,
  head: () => getPageHead('Proxy Vote Jobs'),
  component: BetaNxtJobList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingVendorBetaNxt}
      />
    </VerticalStack>
  );
}

function BetaNxtJobList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ProxyVoteJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
